export * from './payment.module';

export { PaymentComponent } from './components/payment.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/payment/index.ts